import { Brain, ShieldCheck, Cpu, HeartPulse } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const ICONS = [Brain, ShieldCheck, Cpu, HeartPulse];

export const Concept = () => {
  const { t } = useT();
  return (
    <section id="konzept" data-testid="concept-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="al-tag">{t.concept.tag}</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight">
            {t.concept.h2a}<span className="al-grad-text">{t.concept.h2b}</span>
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">{t.concept.sub}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.concept.cards.map((c, i) => {
            const Icon = ICONS[i] || Brain;
            return (
              <div key={c.title} data-testid={`concept-card-${i}`} className="al-card p-7 al-rise" style={{ animationDelay: `${i * 80}ms` }}>
                <div className="h-12 w-12 rounded-2xl al-grad-bg flex items-center justify-center text-white shadow-lg shadow-purple-500/20">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-display font-semibold text-xl">{c.title}</h3>
                <p className="mt-3 text-slate-600 leading-relaxed text-[15px]">{c.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
